<template>
  <div>
    <Button class="mr-2" type="primary" @click="modalStats = true">{{$t('user.table.stats')}}</Button>
    <Modal v-model="modalStats" :title="$t('user.table.stats')" @on-visible-change="modalClose" :mask-closable="false">
      <Form ref="stats-form" :model="formValidate" :rules="ruleValidate" label-position="right" :label-width="80">
        <FormItem :label="$t('user.table.date')" prop="time">
          <date-picker :lang="'ru'" placeholder="Select date" format="DD.MM.YYYY" v-model="formValidate.time" range style="max-width: 80%; width: 210px;"></date-picker>
        </FormItem>

        <FormItem :label="$t('user.table.role')" prop="roles" style="margin-bottom: 5px">
          <Select v-model="formValidate.roles" multiple >
            <Option v-for="item in roles" :value="item.role" :key="item.role">{{ item.title }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" class="text-center">
        <Button type="primary" size="large" :loading="loading" long @click="validateForm()">Download XLS</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import DatePicker from "vue2-datepicker";
export default {
  name: "UsersStats.vue",
  components:{
    DatePicker
  },
  props:["roles"],
  data(){
    return {
      modalStats: false,
      formValidate: {
        time: [],
        roles:[],
      },
      ruleValidate: {
        time: [
          { required: true, type: 'array', message: 'Please select the date', trigger: 'change' },
          { type: 'array', min: 2, message: 'Please select the date', trigger: 'change' }
        ],
        roles: [
          { required: true, type: 'array', min: 1, message: 'Select minim 1 role', trigger: 'blur' }
        ]
      },
      loading:false,
      alert: false
    }
  },
  methods:{
    validateForm(){
      console.log(this.$refs)
      this.$refs["stats-form"].validate( async (valid) => {
        console.log(valid)
        if (valid) {
          await this.getStats();
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    async getStats(){
      this.loading = true;
      let time = [
        this.$moment(this.formValidate.time[0]).startOf('day').toString(),
        this.$moment(this.formValidate.time[1]).endOf('day').toString(),
      ];
      let response = await this.$http.post("/user/statsRole", {
        roles: this.formValidate.roles,
        time
      });
      let rows = response.data.users.map(user => ({
         name: user.name,
        "role": this.roles.find(item => item.role === user.role[0]).title,
        "auftrag": user.invoicesLength,
        "crm": user.crmLength,
        "rech": user.rechnungLength,
        "gutch": user.gutchLength
      }));
      rows = this._.orderBy(rows, ["role", "name"])
      const worksheet = window.XLSX.utils.json_to_sheet(rows);
      const workbook = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(workbook, worksheet, "Dates");

      /* fix headers */
      window.XLSX.utils.sheet_add_aoa(worksheet, [["Name", "Role","Auftrag", "CRM", "RECH", "GUTCH"]], { origin: "A1" });

      /* calculate column width */
      const max_width = rows.reduce((w, r) => Math.max(w, r.name.length), 10);
      worksheet["!cols"] = [ { wch: max_width } ];

      /* create an XLSX file and try to save to Presidents.xlsx */
      XLSX.writeFile(workbook, "Raport.xlsx", { compression: true });
      this.loading = false;
    },
    modalClose() {
      this.formValidate.time = []
      this.formValidate.roles = []
    },
  },
  async mounted(){

  },
  async created(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/UsersStats.vue